module.exports = __webpack_public_path__ + "static/media/isobau_4.aa4ee03c.gif";